    <div class="app-titulo-pagina visible-xs" id="tituloPaginaExtrato">
        <div>Extrato</div>
    </div>

    <input id="length-tabela-extrato" type="hidden" value="{{transacoes?.length}}">

    <div *ngIf="mainService.permissionService.hasPermission('funcionalidade:extrato_limitado')" class="table-responsive">

        <div class="col-xs-12 app-banner">
            <img class="hidden-xs" src="./assets/img/banners/saldo.png" alt="Banner">
            <img class="visible-xs" src="../../assets/img/banners/mobile_saldo.png" alt="Banner Saldo">
        </div>
        <div *ngIf="processando" class="text-center">
            <i class="fa fa-spinner fa-pulse fa-4x"></i>
        </div>

        <table *ngIf="transacoes?.length" class="table table-striped table-hover">

            <thead>
                <tr>
                    <th>
                        <span class="glyphicon glyphicon-arrow-down"></span> Transação</th>
                    <th>Data</th>
                    <th>Descrição</th>
                    <th>Saldo Anterior</th>
                    <th>Pontos</th>
                    <th>Saldo Final</th>
                </tr>
            </thead>

            <tbody id="tabelaExtratoBody">
                <tr *ngFor="let transacao of transacoes">
                    <td>{{ transacao.id }}</td>
                    <td>{{ transacao.dataRegistro| dateFormat:'dd/MM/yyyy HH:mm' }}</td>
                    <td>
                        <button type="button" (click)="selecionarTransacao(transacao)" class="btn app-btn-best" data-toggle="modal" data-target="#detalheTransacao">
                            <i class="fa fa-info-circle"></i> Detalhes
                        </button>
                    </td>
                    <td>{{ transacao.saldoAnteriorPontos }}</td>
                    <td>{{ transacao.pontos }}</td>
                    <td>{{ transacao.saldoAnteriorPontos + transacao.pontos }}</td>
                </tr>
            </tbody>

        </table>
    </div>

    <div style="margin-bottom: 100px;">
        <div class="panel panel-default col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3">

            <div class="panel-body">
                <strong>Saldo Atual: </strong>
                <span id="saldoExtrato">{{ mainService.saldoService.saldoAtualizado() }}</span> pontos <span *ngIf="mainService?.loginService?.saldoService?.saldo?.saldoPontos">({{ applyConversion() | currencyformat }})</span>
                <div *ngIf="mainService.saldoService.saldo.saldoPontosDevedor < 0" style="color: red;">
                    <strong>Saldo a devolver:</strong> {{ mainService.saldoService.saldo.saldoPontosDevedor }} pontos
                    <a data-toggle="modal" data-target="#myModal" style="cursor: pointer;">
                        <i class="fa fa-question-circle" aria-hidden="true"></i>
                    </a>
                </div>
            </div>

        </div>
        <div *ngIf="mainService.cartaoService.cartao.produto.bandeira" style="margin-bottom: 60px;" class="panel panel-default col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3">

            <div class="panel-body">
                <strong>Saldo atual em reais para uso do cartão {{ mainService.cartaoService.cartao.produto.nome }} na rede {{ mainService.cartaoService.cartao.produto.bandeira
                    }}
                    <span *ngIf="mainService.cartaoService.cartao.produto.saque"> e saque na rede 24horas</span>:
                </strong>{{ mainService.saldoService.saldo.saldoMoeda | currency:'BRL':'symbol':'1.2-2':'pt' }}
            </div>

        </div>
    </div>


<div class="modal fade" id="detalheTransacao" tabindex="-1" role="dialog" aria-labelledby="detalheTransacaoLabel" aria-hidden="true">

    <div class="modal-dialog">
        <div class="modal-content col-xs-12">

            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" id="detalheTransacaoLabel">
                    <strong>Descrição</strong>
                </h4>
            </div>

            <div class="modal-body">
                <span *ngIf="mainService.downloadService.processando === false" 
                    [innerHTML]="transacaoSelecionada?.descricao?.replaceAll(';', ';<br>')">
                    <!-- {{ transacaoSelecionada.descricao }} -->
                </span>


                <div *ngIf="mainService.downloadService.processando" class="text-center">
                    <i class="fa fa-spinner fa-pulse fa-4x"></i>
                </div>

            </div>

            <div class="modal-footer">
                <a *ngIf="transacaoSelecionada.origem === 'transferencia_bancaria' 
                    || transacaoSelecionada.tarifa === 0 
                    || transacaoSelecionada.origem === 'pagamento_boleto' 
                    || transacaoSelecionada.origem === 'pagamento_conta_consumo'
                    || transacaoSelecionada.origem === 'pix'"
                          id="linkComprovante-{{ transacaoSelecionada.origemId }}"
                    (click)="mainService.downloadService.getComprovante(transacaoSelecionada)" class="btn app-btn-best">
                    <i class="fa fa-info-circle"></i> Comprovante
                </a>
                <button type="button" class="btn btn-danger-v2" data-dismiss="modal" id="btn-modal-fechar">Fechar</button>
            </div>

        </div>
    </div>
</div>



<!-- Modal -->
<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" id="myModalLabel">Saldo a Devolver</h4>
            </div>
            <div class="modal-body">
                Foram realizadas transações usando saldo indisponivel no seu cartão.
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal" id="btn-modal-fechar">Fechar</button>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/extrato/extrato.component.html